/**
 * @generated SignedSource<<c1b00362f2ad4b0ebbe5f356ffa39e18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type OrderHistoryViewerQuery$variables = {};
export type OrderHistoryViewerQuery$data = {
  readonly viewer: {
    readonly user: {
      readonly id: string;
      readonly role: string;
    } | null;
  };
};
export type OrderHistoryViewerQuery = {
  response: OrderHistoryViewerQuery$data;
  variables: OrderHistoryViewerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrderHistoryViewerQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrderHistoryViewerQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "edd61b3d94726c5bf3e26695f07b6911",
    "id": null,
    "metadata": {},
    "name": "OrderHistoryViewerQuery",
    "operationKind": "query",
    "text": "query OrderHistoryViewerQuery {\n  viewer {\n    user {\n      id\n      role\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a25eeef25d074e8b0fa2f1ad31d49b18";

export default node;
